import { jsx as _jsx } from "preact/jsx-runtime";
// @ts-ignore
import { createRootFragment } from "preact-root-fragment";
import { render } from "preact";
import { useEffect, useRef, useState } from "preact/hooks";
const GlowingVideo = (props) => {
    const canvasRef = useRef(null);
    const [ctx, setCtx] = useState();
    const [step, setStep] = useState(0);
    useEffect(() => {
        if (!canvasRef.current) {
            return;
        }
        const currentCtx = canvasRef.current.getContext("2d");
        setCtx(currentCtx);
        currentCtx.filter = "blur(1px)";
        props.videoElement.addEventListener("loadeddata", draw, false);
        props.videoElement.addEventListener("seeked", draw, false);
        props.videoElement.addEventListener("play", drawLoop, false);
        props.videoElement.addEventListener("pause", drawPause, false);
        props.videoElement.addEventListener("ended", drawPause, false);
    }, [canvasRef]);
    const cleanup = () => {
        props.videoElement.removeEventListener("loadeddata", draw);
        props.videoElement.removeEventListener("seeked", draw);
        props.videoElement.removeEventListener("play", drawLoop);
        props.videoElement.removeEventListener("pause", drawPause);
        props.videoElement.removeEventListener("ended", drawPause);
    };
    const draw = () => {
        if (!ctx || !canvasRef.current) {
            return;
        }
        ctx.drawImage(props.videoElement, 0, 0, canvasRef.current.width, canvasRef.current.height);
    };
    const drawLoop = () => {
        draw();
        setStep(window.requestAnimationFrame(drawLoop));
    };
    const drawPause = () => {
        window.cancelAnimationFrame(step);
        setStep(0);
    };
    window.addEventListener("unload", cleanup, false);
    return _jsx("canvas", { class: "soul-video-container__canvas", ref: canvasRef });
};
function autoInitGlowingVideos() {
    if (window.videosInitialized)
        return;
    window.videosInitialized = true;
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (mediaQuery.matches) {
        return;
    }
    const videoElements = document.querySelectorAll("video");
    const wrapElement = (element) => {
        var _a;
        const container = document.createElement("div");
        container.classList.add("soul-video-container");
        (_a = element.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(container, element);
        container.appendChild(element);
        const target = document.createElement("div");
        container.appendChild(target);
        return [container, target];
    };
    videoElements.forEach((video) => {
        const [container, target] = wrapElement(video);
        render(_jsx(GlowingVideo, { videoElement: video }), createRootFragment(container, target));
    });
}
export default GlowingVideo;
export { autoInitGlowingVideos };
